import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import DepartmentImage from '../../../assets/image/department/usa-army-soldiers-with-flag-background-greeting-card-memorial-day-america-celebration_742418-27414.jpg';
import DepartmentImage2 from '../../../assets/image/department/military-man-suffering-from-ptsd-having-psychologist-session_23-2149307566.jpg';

function VeteransAffairs() {

  const [Faq, setFaq] = useState(0);

  const Drop = [
    {
      Que: "What benefits are available for veterans?",
      Answer: "The Department of Veterans Affairs provides healthcare services, housing assistance, and educational benefits for veterans."
    },
    {
      Que: "How can I access mental health resources?",
      Answer: "Veterans can access mental health support through VA clinics, hotlines, and community-based programs."
    },
    {
      Que: "What employment resources are offered for veterans?",
      Answer: "We provide job placement services, career counseling, and skills training programs to help veterans transition to civilian careers."
    }
  ];

  return (
    <>
      <section className="department-details-section">
        <div className="container">
          <div className="row">

            {/* Sidebar */}
            <div className="col-12 col-lg-4 col-xl-4">
              <Sidebar />
            </div>

            {/* Main Content */}
            <div className="col-lg-8">
              <div className="department-details-imgbox">
                <img src={DepartmentImage} className="img-fluid" alt="Veterans Affairs" />
              </div>

              <div className="department-details-content-box">
                <h4 className="department-details-title">Veterans Affairs</h4>
                <p>
                  The Department of Veterans Affairs is dedicated to supporting those who have served our country by providing essential services and resources. 
                  Our mission is to honor veterans by ensuring access to healthcare, housing, and career opportunities, empowering them to lead fulfilling lives.
                </p>
              </div>

              <div className="department-details-box">
                <div className="department-details-policy">
                  <span>
                    Committed to serving veterans and their families with dignity and respect.
                  </span>
                </div>
                <p>
                  Through tailored programs and partnerships, we address the unique challenges faced by veterans, offering comprehensive support for their well-being and integration into society.
                </p>
              </div>

              <div className="department-details-benefits-inner-box">
                <div className="row row-gutter-30">
                  <div className="col-lg-6">
                    <div className="department-details-benefits-box-image">
                      <img src={DepartmentImage2} className="img-fluid" alt="Veterans Services" />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="department-details-benefits-box">
                      <h3>Our Benefits</h3>
                      <p>
                        Providing veterans with the resources they need to thrive.
                      </p>
                      <ul className="list-unstyled list-style">
                        <li>
                          <Link to="/department/veterans/health-wellness">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Veterans’ Health and Wellness Services
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/veterans/job-training">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Employment and Job Training Programs for Veterans
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/veterans/housing-support">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Housing Assistance and Homelessness Prevention
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/veterans/benefits-claims">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Veterans' Benefits and Claims Assistance
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordian-box">
                {Drop.map((items, index) => (
                  <div className={`accordian-box-item ${Faq !== index && "active"}`} key={index}>
                    <div className="accordian-title">
                      <h5>{items.Que}</h5>
                      <i className="fa-solid fa-angle-right" onClick={() => setFaq(index)} />
                    </div>

                    {Faq === index && (
                      <div className="accordian-content" style={{ display: "block" }}>
                        <p>{items.Answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default VeteransAffairs;
